import { getWdOrigin } from './getWdOrigin';
export function getOriginParam(workload, route, docaspxEnabled, isTemplate) {
    var wdOriginType = isTemplate
        ? docaspxEnabled
            ? "TEMPLATES-INSTANT" /* WdOriginType.InstantTemplates */
            : "TEMPLATES" /* WdOriginType.Templates */
        : docaspxEnabled
            ? "NEW-INSTANT" /* WdOriginType.InstantNew */
            : "NEW" /* WdOriginType.New */;
    return getWdOrigin(workload, route, wdOriginType);
}
//# sourceMappingURL=getOriginParam.js.map